// extracted by mini-css-extract-plugin
export default {"container":"Parts_container__J9Z8x","moreBtn":"Parts_moreBtn__xLC6f","card":"Parts_card__hLcf-","card_Inner":"Parts_card_Inner__HRvTX","name_price":"Parts_name_price__k6lY7"};